import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
export function MenuList({ className, children }) {
    return (_jsx("ul", { className: `${className} space-y-1 flex flex-col items-start`, children: children }));
}
const MenuListItem = forwardRef(function _MenuListItem(props, ref) {
    const { current, children, className, href = '#', onClick, ...others } = props;
    return (_jsx("li", { className: clsx(className, current ? 'bg-muted' : '', 'w-full p-2 pl-3 text-sm leading-6 font-semibold hover:bg-muted'), children: _jsx("a", { ref: ref, href: href, onClick: (e) => {
                if (onClick) {
                    e.preventDefault();
                    onClick(e);
                }
                else if (href === '#') {
                    e.preventDefault();
                }
            }, className: 'w-full flex items-center gap-x-3', ...others, children: children }) }));
});
MenuList.Item = MenuListItem;
//# sourceMappingURL=MenuList.js.map